export const GLOBAL_STATE = 'userOpenLink'

export const USER_OPEN_LINK = 'USER_OPEN_LINK' as const
export const CHECK_USER_OPEN_LINK = 'CHECK_USER_OPEN_LINK' as const
export const USER_PUBLIC_INFO = 'USER_PUBLIC_INFO' as const
